import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import {
  Col,
  Row,
  FormGroup,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  InputGroup,
  FormFeedback,
  FormText,
} from "reactstrap";
import InputLabel from "@mui/material/InputLabel";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import PDF from "../pdfGenerate/pdf";
import AuditPDF from "../pdfGenerate/auditpdf";
import Popover from "./Popover";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs(props) {
  const {
    selected,
    itemgroupselected,
    backup,
    component,
    cisresult,
    overallAudit,
    failedAudit,
    hostname,
    ipdns,
    platform,
    exedate,
    passedaudit,
    manualAudit,
    skippedAudit,
    fixedAudit,
    userdata,
    setUserdata,
    headerselected,
    headeroverallselected,
    itemheaderselected,
  } = props;

  const [factresult, setFactresult] = React.useState([]);
  React.useEffect(() => {
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(`${process.env.REACT_APP_API_URL}/api/auditoverallview/${auditID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setFactresult(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [databackup, setDatabackup] = React.useState(false);

  const [assignuserdata, setAssignuserdata] = React.useState([]);
  const [newstate, setNewstate] = React.useState([]);
  const [tempselected, setTempselected] = React.useState([]);
  const [oldselected, setOldselected] = React.useState([]);

  const IndualClickOpen = (e) => {
    e.preventDefault();
    userdata.map((userdata) => {
      selected.map((cisdata) => {
        if (cisdata === userdata.no) {
          setNewstate((prevState) => ({
            ...prevState,
            [userdata.variable]: userdata.output,
          }));
          setAssignuserdata((prevState) => ({
            ...prevState,
            [userdata.variable]: userdata.output,
          }));
        }
      });
    });

    if (backup === "yes") {
      setDatabackup(true);
    }
    handleClickOpen();
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setNewstate((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    setAssignuserdata((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const Submit = (selected) => (e) => {
    e.preventDefault();
    var value1 = JSON.stringify(newstate);
    var backupdata;
    if (databackup) {
      backupdata = "yes";
    } else {
      backupdata = "no";
    }

    let sub = {
      host_id: window.sessionStorage.getItem("hostID").toString(),
      audit_id: window.sessionStorage.getItem("auditID").toString(),
      tags: selected.toString(),
      user_data: value1,
      backup_data: backupdata,
      // host_userdata: value2
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/run_remedy`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(sub),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.detail);
        window.localStorage.setItem("remedy_run_limit", data.detail);
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
        window.location.href = "/admin/remedy";
      })
      .catch((error) => {
        console.log(error);
        window.location.href = "/admin/remedy";
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
      });
    setOpen(false);
  };

  const handleChangecheck = (event) => {
    setDatabackup(event.target.checked);
  };

  const isSelected = (cis_no) => selected.indexOf(cis_no) !== -1;
  const isHeaderSelected = (no) => headerselected.indexOf(no) !== -1;
  const isOverallHeaderItemSelected = (no) =>
    itemheaderselected.indexOf(no) !== -1;
  const renderFields = (userdata, selected) => {
    return userdata.map((field) => {
      let { no, name, output, variable, type, hint, only_applicable, header } =
        field;
      const isItemSelected = isSelected(no);
      const isHeaderItemSelected = isHeaderSelected(no);
      const isOverallHeaderSelected = isOverallHeaderItemSelected(no);

      if (
        isItemSelected ||
        (header === "yes" && isOverallHeaderSelected && headeroverallselected)
      ) {
        switch (type) {
          case "password":
            return (
              <React.Fragment>
                {field.based_on &&
                newstate[field.based_on] === only_applicable ? (
                  <React.Fragment>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={newstate[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                    <br />
                    <br />
                  </React.Fragment>
                ) : !field.based_on ? (
                  <React.Fragment>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={newstate[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                    <br />
                    <br />
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
            case "number":
              return (
                <React.Fragment>
                  {field.based_on &&
                  newstate[field.based_on] === only_applicable ? (
                    <React.Fragment>
                      <InputLabel
                        style={{ fontSize: "small" }}
                        htmlFor="component-simple"
                      >
                        {" "}
                        {name} <Popover hint={hint} />
                      </InputLabel>
                      <TextField
                        id={variable}
                        value={newstate[variable]}
                        onChange={handleChange}
                        type={type}
                        fullWidth
                        size="medium"
                      />
                      <br />
                      <br />
                    </React.Fragment>
                  ) : !field.based_on ? (
                    <React.Fragment>
                      <InputLabel
                        style={{ fontSize: "small" }}
                        htmlFor="component-simple"
                      >
                        {" "}
                        {name} <Popover hint={hint} />
                      </InputLabel>
                      <TextField
                        id={variable}
                        value={newstate[variable]}
                        onChange={handleChange}
                        type={type}
                        fullWidth
                        size="medium"
                      />
                      <br />
                      <br />
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              );              
          case "text":
            return (
              <React.Fragment>
                {field.based_on &&
                newstate[field.based_on] === only_applicable ? (
                  <React.Fragment>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={newstate[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                    <br />
                    <br />
                  </React.Fragment>
                ) : !field.based_on ? (
                  <React.Fragment>
                    <InputLabel
                      style={{ fontSize: "small" }}
                      htmlFor="component-simple"
                    >
                      {" "}
                      {name} <Popover hint={hint} />
                    </InputLabel>
                    <TextField
                      id={variable}
                      value={newstate[variable]}
                      onChange={handleChange}
                      type={type}
                      fullWidth
                      size="medium"
                    />
                    <br />
                    <br />
                  </React.Fragment>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          case "select":
            return (
              <React.Fragment>
                <InputLabel
                  style={{ fontSize: "small" }}
                  htmlFor="component-simple"
                >
                  {" "}
                  {name} <Popover hint={hint} />
                </InputLabel>
                <TextField
                  id={variable}
                  value={newstate[variable]}
                  onChange={handleChange}
                  type={type}
                  fullWidth
                  size="medium"
                  select
                  SelectProps={{ native: true }}
                >
                  <option key="" value=""></option>
                  {field.options.map((row) => {
                    return (
                      <React.Fragment>
                        <option value={row}>{row}</option>
                      </React.Fragment>
                    );
                  })}
                </TextField>
                <br />
                <br />
              </React.Fragment>
            );
          default:
            return (
              <div key={name}>
                <span className="red-text">
                  {name} {type}
                </span>
              </div>
            );
        }
      }
    });
  };

  return (
    <>
      <button
        className="bg-blueGray-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        <Link
          to={{
            pathname: "/admin/audit",
          }}
          style={{ color: "#FFF" }}
        >
          <i className="mr-2 text-x">
            <ArrowBackIosIcon size="small" fontSize="small" />
          </i>
          Back
        </Link>
      </button>
      <AuditPDF
        component={component}
        cisresult={factresult.Result}
        overallAudit={overallAudit}
        failedAudit={failedAudit}
        hostname={hostname}
        ipdns={ipdns}
        platform={platform}
        exedate={exedate}
        passedaudit={passedaudit}
        manualAudit={manualAudit}
        skippedAudit={skippedAudit}
        fixedAudit={fixedAudit}
      />      
      <PDF
        component={component}
        cisresult={factresult.Result}
        overallAudit={overallAudit}
        failedAudit={failedAudit}
        hostname={hostname}
        ipdns={ipdns}
        platform={platform}
        exedate={exedate}
        passedaudit={passedaudit}
        manualAudit={manualAudit}
        skippedAudit={skippedAudit}
        fixedAudit={fixedAudit}
      />
      <button
        disabled={
          selected.length > 0 || itemgroupselected.length > 0 ? false : true
        }
        className={
          selected.length > 0 || itemgroupselected.length > 0
            ? "bg-lightBlue-500  text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            : "bg-blueGray-200  text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        }
        type="button"
        style={{ float: "right" }}
        onClick={IndualClickOpen}
      >
        {selected.length > 0 || itemgroupselected.length > 0 ? (
          <i className="mr-2 text-x">
            <CheckBoxIcon size="small" fontSize="small" />
          </i>
        ) : (
          <i className="mr-2 text-x">
            <CheckBoxOutlineBlankIcon size="small" fontSize="small" />
          </i>
        )}
        Fix Selected
      </button>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            USER DATA
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Form>
              <Drawer />
              {userdata.length === 0 ? (
                ""
              ) : (
                <React.Fragment>
                  {renderFields(userdata, selected)}
                </React.Fragment>
              )}
            </Form>
            <Grid container spacing={0}>
              <Grid item xs={1}>
                <Checkbox
                  checked={databackup}
                  onChange={handleChangecheck}
                  value="true"
                />
              </Grid>
              <Grid item xs={11}>
                <Typography gutterBottom>
                  I agree that i have backup of the Server before running this
                  Remedy, so that I will be able to restore the server if the
                  remediation makes the server unusable.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <button
              className="font-bold outline uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none "
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              disabled={databackup ? false : true}
              className={
                databackup
                  ? "bg-red-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              }
              type="button"
              onClick={Submit(selected)}
            >
              <Link to="/admin/remedy">FIX IT</Link>
            </button>
          </DialogActions>
        </BootstrapDialog>
      </div>
    </>
  );
}